import Login from './Auth/Login';
import ForgetPassword from './Auth/ForgetPassword';
import SetPassword from './Auth/SetPassword';
import Dashboard from './Dashboard';
import UserManagement from './UserManagement';
import Reports from './Reports';
import Cart from './Cart';
import Product from './Product';
import Purchases from './Purchases';
import Receipt from './Receipt';
import JobOffer from './JobOffer';
import JobApplication from './JobApplication';

export { Login, ForgetPassword, SetPassword };
export {
  Dashboard,
  UserManagement,
  Reports,
  Cart,
  Product,
  Purchases,
  Receipt,
  JobOffer,
  JobApplication,
};
